<!-- REV-18627 (C1b, B7/B20/§5.1): Warn-Oberfläche des DATEV-Automappings. Der Formatkonflikt
     trägt die verabredete Test-ID + einen eindeutigen Marker; die übrigen Warnarten laufen als Liste,
     je Warnung mit data-warning-kind.
     REV-22122: EIN Hinweisbereich statt zweier Kästen, schliessbar; die unzugeordneten Konten stehen
     nur noch in der Kontenliste links vom Baum (`data-grid`, Test-ID `datev-unmapped-accounts`).
     Der Text jedes Eintrags kommt aus `mappingWarningText`: Schlüssel und Postennamen stammen aus der
     Datei und werden erst NACH i18next eingesetzt (SRR REV-22122 F1). -->
<div class="datev-mapping-notice" data-testid="datev-mapping-warnings" role="status" *ngIf="showMappingWarnings">
    <div class="datev-mapping-notice__body">
        <p
            class="datev-mapping-notice__text"
            data-testid="datev-format-mismatch-warning"
            data-warning-kind="FORMAT_MISMATCH"
            *ngIf="hasFormatMismatchWarning"
        >
            {{ 'aumico_templates_account_mapping_form_datev_format_mismatch_warning' | i18next }}
        </p>
        <ul
            class="datev-mapping-notice__list"
            [class.datev-mapping-notice__list--single]="otherMappingWarnings.length === 1"
            *ngIf="otherMappingWarnings.length > 0"
        >
            <li *ngFor="let warning of otherMappingWarnings" [attr.data-warning-kind]="warning.kind">
                {{ mappingWarningText(warning) }}
            </li>
        </ul>
    </div>
    <button
        type="button"
        class="datev-mapping-notice__close"
        data-testid="datev-mapping-warnings-dismiss"
        [attr.aria-label]="'aumico_templates_account_mapping_form_datev_warnings_dismiss' | i18next"
        [attr.title]="'aumico_templates_account_mapping_form_datev_warnings_dismiss' | i18next"
        (click)="dismissMappingWarnings()"
    >
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<div class="align-right">
    <button class="mapping-button" aum-button data-testid="account-mapping-automap" (click)="onSMEClick()">
        {{ 'aumico_templates_account_mapping_form_map_sme_account_plan' | i18next }}
    </button>
    <button
        *ngIf="profitOfTheYearFliName != null && !automaticTransferToggleOn"
        class="mapping-button"
        aum-button
        (click)="onMapIncomeTotalToProfitOfTheYearClick()"
    >
        {{ 'aumico_templates_account_mapping_form_map_income_total' | i18next }}
    </button>
    <button
        *ngIf="importedAnnualSurplusFliName != null || annualSurplusFliName != null"
        class="mapping-button"
        aum-button
        (click)="onMapIncomeTotalToAnnualSurplusClick()"
    >
        {{ 'aumico_templates_account_mapping_form_map_income_total_to_annual_surplus' | i18next }}
    </button>
    <button
        *ngIf="showUncoveredShortFallButton"
        class="mapping-button"
        aum-button
        (click)="onApplyUncoveredShortfallClick()"
    >
        {{ 'aumico_templates_account_mapping_form_apply_uncovered_shortfall' | i18next }}
    </button>
</div>

<mat-tab-group class="account-mapping-tabs">
    <mat-tab label="{{ 'aumico_templates_account_mapping_form_balance' | i18next }}">
        <templates-account-mapping-child-form
            [businessModel]="businessModel"
            type="balance"
            [currency]="currency"
            [languages]="languages"
            [reportLocale]="reportLocale"
            [engine]="balanceEngine"
            [hasPreviousData]="hasPreviousData"
            [profitOfTheYearFliName]="selectedForTransferProfit"
            [errorInProfitFli]="errorInProfitFli"
            [isAutomaticTransferOfAnnualResultEnabled]="automaticTransferToggleOn"
            [cashAndCashFli]="cashAndCashFli"
            [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
            [disableEditingPreviousYearValue]="isPreviousDataTakenFromPreviousBalanceAnnualReport"
            [supportOperation]="supportOperation"
            (dataChangedEventEmitter)="balanceChanged($event)"
            (addOrUpdateAccountInActiveReport)="onAddOrUpdateActiveReport($event)"
            (fliOrGroupDeleted)="onFliOrGroupDeleted($event)"
        >
        </templates-account-mapping-child-form>
    </mat-tab>
    <mat-tab label="{{ 'aumico_templates_account_mapping_form_income' | i18next }}">
        <templates-account-mapping-child-form
            [businessModel]="businessModel"
            type="income"
            [currency]="currency"
            [languages]="languages"
            [reportLocale]="reportLocale"
            [engine]="incomeEngine"
            [hasPreviousData]="hasPreviousData"
            [errorInProfitFli]="errorInProfitFli"
            [isAutomaticTransferOfAnnualResultEnabled]="automaticTransferToggleOn"
            [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
            [disableEditingPreviousYearValue]="isPreviousDataTakenFromPreviousIncomeAnnualReport"
            [supportOperation]="supportOperation"
            (dataChangedEventEmitter)="incomeChanged($event)"
            (addOrUpdateAccountInActiveReport)="onAddOrUpdateActiveReport($event)"
        >
        </templates-account-mapping-child-form>
    </mat-tab>
    <mat-tab label="{{ 'aumico_annual_report_mapping_settings_section' | i18next }}">
        <div #settingsContent class="settings-content">
            <div class="temporary-fix" *ngIf="balanceEngine">
                <span>
                    {{ 'aumico_annual_report_mapping_transfer_profit_fli_change_help_text' | i18next }}
                </span>
                <div class="form-element">
                    <aum-select
                        placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                        [aumFormControl]="specialFunctionsForm.controls['selectedForTransferProfit']"
                        [options]="mappendBalanceFlis"
                    >
                        <aum-form-field-label>
                            {{ 'aumico_annual_report_mapping_help_text_select_fli' | i18next }}
                        </aum-form-field-label>
                    </aum-select>

                    <aum-toggle
                        class="options-button"
                        (changed)="onAutomaticTransferToggleChange($event)"
                        [aumFormControl]="specialFunctionsForm.controls['automaticTransferToggleOn']"
                    >
                        {{ 'aumico_annual_report_mapping_help_automatic_transfer_toggle_text' | i18next }}
                    </aum-toggle>
                </div>
                <span>
                    {{ 'aumico_annual_report_mapping_transfer_surplus_fli_change_help_text' | i18next }}
                </span>
                <div class="form-element">
                    <aum-select
                        placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                        [aumFormControl]="specialFunctionsForm.controls['selectedForAnnualSurplus']"
                        [options]="mappendBalanceFlis"
                    >
                        <aum-form-field-label>
                            {{ 'aumico_annual_report_mapping_help_text_select_fli' | i18next }}
                        </aum-form-field-label>
                    </aum-select>
                </div>
                <ng-container *ngIf="showUncoveredShortFallButton">
                    <span>
                        {{ 'aumico_annual_report_mapping_uncovered_shortfall_assets_fli_help_text' | i18next }}
                    </span>
                    <div class="form-element">
                        <aum-select
                            placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                            [aumFormControl]="specialFunctionsForm.controls['selectedUncoveredShortfallAssetsFli']"
                            [options]="mappendBalanceFlis"
                        >
                            <aum-form-field-label>
                                {{ 'aumico_annual_report_mapping_help_text_select_fli' | i18next }}
                            </aum-form-field-label>
                        </aum-select>
                    </div>
                    <span>
                        {{ 'aumico_annual_report_mapping_uncovered_shortfall_liabilities_fli_help_text' | i18next }}
                    </span>
                    <div class="form-element">
                        <aum-select
                            placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                            [aumFormControl]="specialFunctionsForm.controls['selectedUncoveredShortfallLiabilitiesFli']"
                            [options]="mappendBalanceFlis"
                        >
                            <aum-form-field-label>
                                {{ 'aumico_annual_report_mapping_help_text_select_fli' | i18next }}
                            </aum-form-field-label>
                        </aum-select>
                    </div>
                </ng-container>
            </div>

            <div class="temporary-fix">
                <span>
                    {{ 'aumico_annual_report_mapping_reset_fli_warning' | i18next }}
                </span>
                <button class="mapping-button" aum-button (click)="openResetFliDialog()">
                    {{ 'aumico_annual_report_mapping_reset_fli_button' | i18next }}
                </button>
            </div>
            <div class="temporary-fix">
                <span>
                    {{ 'aumico_annual_report_mapping_load_fli_cfs_settings_warning' | i18next }}
                </span>
                <button class="mapping-button" aum-button (click)="openLoadFliCfsSettingsDialog()">
                    {{ 'aumico_annual_report_mapping_load_fli_cfs_settings_button' | i18next }}
                </button>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
